import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type ReferralState = {
  referralId: string | null;
};

type ReferralStateAction = {
  setReferralId: (referralId: ReferralState["referralId"]) => void;
};

const initialValue: ReferralState = {
  referralId: null,
};

export const useReferralStore = create<ReferralState & ReferralStateAction>()(
  persist(
    (set) => ({
      ...initialValue,
      setReferralId: (id) => set({ referralId: id }),
    }),
    {
      name: "referral-store",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
